import { useCallback, useEffect, useState } from 'react';

const KIOSK_MODE_STORAGE_KEY = 'posKioskMode';

const readKioskMode = (): boolean => localStorage.getItem(KIOSK_MODE_STORAGE_KEY) === 'true';

export function useKioskMode() {
  const [isKioskMode, setIsKioskMode] = useState(readKioskMode);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === KIOSK_MODE_STORAGE_KEY) setIsKioskMode(readKioskMode());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const toggleKioskMode = useCallback(() => {
    setIsKioskMode((current) => {
      const next = !current;
      localStorage.setItem(KIOSK_MODE_STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  return { isKioskMode, toggleKioskMode };
}
